import React from "react";
import {Form, Input, Radio, Upload, Button, Icon, message,Divider,Row,Col} from 'antd';
import NHFormItem from '../common/NHFormItem';
import NHSelect from '../common/NHSelect';
const FormItem = Form.Item;
import NHFetch from "../../utils/NHFetch";

const baseUrlPath = "/studentPhoto"; //基础路径

/**
 * studentPhoto编辑表单
 * @author Xiafanglin
 * @date 2018-03-10 03:51:42
 * Version: 1.0
 */
class UploadForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            fileList:[],
            uuid:undefined,
        }
    }
    //上传改变触发事件
    onChange = (info) => {
        let fileList = info.fileList;
        fileList = fileList.slice(-1);
        
        fileList = fileList.filter((file) => {
            if (file.response) {
                if (file.response.data){
                    this.setState({ uuid : file.response.data});
                }
                return file.response.code == '200';
            }
            return true;
        });
        this.setState({ fileList });
    }
    
    //上传前调用方法
    beforeUpload(file) {
        if(file.type == ""){
            if(file.name.indexOf(".zip") == -1 && file.name.indexOf(".ZIP") == -1){
                message.error('只能上传zip文件！');
                return false;
            }else{
                return true;
            }
        }else{
            const valid = file.type.indexOf('zip')!=-1;
            if (!valid) {
                message.error('只能上传zip文件！');
            }
            return valid;
        }
    }
    render() {

        const {getFieldDecorator,setFieldsValue} = this.props.form;
        const initFormData = this.props.initFormData;
        const props = {
            name: 'file',
            action: 'api/pub-stuinfo/studentPhoto/createTemp',
            beforeUpload: this.beforeUpload,
            multiple: true,
            onChange:this.onChange,
        };

        return (
            <div style={{width:'90%'}}>
                <div style={{color:"red"}}>
                    <Row gutter={24}>
                        <Col span={1}>
                            注：
                        </Col>
                        <Col span={22}>
                            <p>1.只能导入zip格式压缩包！</p>
                            <p>2.zip包大小不要超过100M！</p>
                            <p>3.照片命名格式为【编号.jpg】（编号指账号类型中的一种即考生号、准考证号、学号、录取号或身份证号）</p>
                            <p>4.压缩包中不可存在文件夹，系统无法解析，请将照片直接放到压缩包下</p>
                            <p>（即选中照片本身进行压缩，不要将整个文件夹进行压缩）</p>
                        </Col>
                    </Row>
                </div>
                <Divider />
                <div style={{margin:"16px"}}>
                    <Form layout="horizontal">
                        <div style={{display:'none'}}>
                            <NHFormItem id={"uuid"} label={"文件id:"} required={true}
                                        form={this.props.form} initialValue={this.state.uuid}>
                                <input />
                            </NHFormItem>
                        </div>
                        <NHFormItem id={"zhlx"} label={"账号类型:"} required={true}
                                    form={this.props.form} >
                            <NHSelect sign={"DMK_YXXT_ZHLX"} style={{width:"100%"}} />
                        </NHFormItem>
                        <NHFormItem id={"file"} label={"照片压缩包:"} required={true}
                                    form={this.props.form} >
                            <Upload {...props} fileList={this.state.fileList}>
                                <Button>
                                    点击上传
                                </Button>
                            </Upload>
                        </NHFormItem>
                    </Form>
                </div>

            </div>
        );
    }
}

const UploadZipForm = Form.create()(UploadForm);

export default UploadZipForm;


// WEBPACK FOOTER //
// ./components/stuPhotoMng/upload.js